const vn = {
    scanAddSuccess: 'Đã thêm đơn quét thành công',
    scanAddFail: 'Không thêm được đơn quét',
    tip: 'Lời nhắc',
    delScanTip1: 'Bạn có chắc muốn xóa đơn quét này không? Dữ liệu sẽ không thể khôi phục sau khi xóa.',
    scanDelSuccess: 'Đã xóa đơn quét thành công',
    addScan: 'Thêm đơn quét mới',
    scanCount: 'Tổng số mặt hàng đã quét {{count}}',
    oprtName: 'Người vận hành: {{name}}',
    enterCode: 'Vui lòng nhập mã vạch',
    cancel: 'Hủy bỏ',
    confirm: 'Xác nhận',
    sameCheck: 'Kiểm tra trùng lặp',
    conIn: 'Xác định thư viện',
    conOut: 'Xác định thư viện',
    addScanTip:"Dữ liệu được phân chia theo mặc định là'space'và'enter' và mã vạch lặp lại sẽ bị xóa sau khi nhập xong.",
    scanSheet1: 'Danh sách quét 1',
    sameBarcodeTip1: 'Có sự trùng lặp mã vạch trong cùng một sản phẩm, vui lòng gửi lại sau khi sửa đổi dữ liệu.',
    sameBarcodeTip2: 'Mã vạch trùng lặp tồn tại trong phiếu quét, vui lòng kiểm tra để gửi lại dữ liệu.',
    confirmClearData: 'Trang hiện tại đã có nội dung, xác nhận xóa dữ liệu chưa?',
    scanSheetNum: 'Máy quét {{num}}',
    scanSheetCount: 'Máy quét {{count}}',
    fillBarcodeFirst: 'Vui lòng điền mã vạch trước khi thêm dữ liệu.',
    selProductForBarcode: 'Hàng hóa: ',
    selProductForBarcodePl: 'Vui lòng chọn sản phẩm cho mã vạch',
    clear: 'Xoá',
    addNew: 'Mới',
    scanSheetData: 'Quét dữ liệu đơn',
    addScanMax: 'Tối đa chỉ có thể thêm {{num}} thẻ quét',
    scanNumExceedMax: 'Số lượng mã vạch vượt quá giới hạn tối đa',
    scanNumExceedMaxTip: 'Bạn chỉ có thể nhập tối đa {{num}} mã vạch.',
    residueBarcodeNum: 'Bạn có thể thêm {{residueNum}} mã vạch, vui lòng gửi lại sau khi sửa đổi dữ liệu.',
    confirmDelBarcodesNum: 'Xác nhận xóa {{delNum}} mã vạch đã chọn?',
    delText: 'Xoá',
    saveText: 'Lưu',
    saveAndAdd: 'Lưu và thêm',
    addBarcodes: 'Thêm mã vạch',
    delBarcodes: 'Xóa mã vạch',
    notFoundBarcodes: 'Không truy vấn mã vạch',
    confirmClearDataTip: 'Nội dung trang hiện tại chưa được lưu, bạn có xác nhận xóa không?',
    searchBarcodePlaceholder: 'Vui lòng nhập mã vạch tìm kiếm',
    notSelectedBarcode: 'Hiện tại chưa chọn Xóa mã vạch',
    noDelScanSheet: 'Nếu chỉ còn một phần dữ liệu là dữ liệu mặc định, không thể xóa bỏ.',
    butDelTooltip: 'Xóa dữ liệu hàng hóa và mã vạch hiện tại',
    butSaveTooltip: 'Lưu dữ liệu đơn quét hiện tại',
    butSaveAndAddTooltip: 'Lưu dữ liệu Scan Single và thêm Scan Single mới',
    manufactureBarcode: 'Tạo mã vạch hàng loạt',
    barcodeNotEmpty: 'Dữ liệu mã vạch không được để trống',
    saveScanTip: 'Vui lòng lưu danh sách quét hiện tại',
    barcodePrefix: 'Mã vạch Prefix',
    barcodeSuffix: 'Hậu tố mã vạch',
    barcodeStartNum: 'Mã vạch Bắt đầu số',
    barcodeEndNum: 'Mã vạch Số cuối',
    barcodeMaxCount: 'Giới hạn số lượng sản xuất tối đa ({{maxCount}})',
    generateBarcode: 'Tạo mã vạch',
    scanDataFillTip: 'Vui lòng điền đầy đủ dữ liệu đã quét',
    allCheckBarcodes: 'Chọn tất cả',
    endLessThanStart: 'Số kết thúc không được nhỏ hơn số bắt đầu',
    selectProductTip: 'Vui lòng chọn sản phẩm',
    barcodeTip: 'Vui lòng điền mã vạch',
    productAndBarcodeTip: 'Vui lòng chọn sản phẩm và điền mã vạch',
    delInInventory: 'Xóa và xác định thư viện',
    delOutInventory: 'Xóa và xác định thư viện',
    selectPl: 'Vui lòng chọn',
};

export default vn;